const userChangePasswordFormSchema = {
  type: 'object',
  required: ['currentPassword', 'newPassword', 'newPasswordConfirmation'],
  properties: {
    newPassword: {
      type: 'string',
      minLength: 6,
      maxLength: 18,
      pattern: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@.#$!%*?&^()]).+$/
        .toString()
        .slice(1, -1),
      errorMessage: {
        pattern:
          'must contain at least one lower, one upper, one numeric, and one special character',
      },
    },
    newPasswordConfirmation: {
      type: 'string',
      const: {
        $data: '1/newPassword',
      },
      errorMessage: {
        const: 'should match new password',
      },
    },
  },
};

export { userChangePasswordFormSchema };
